'use client';

import { useTranslations } from 'next-intl';
import { HoloCard } from './HoloCard';

interface ScanningStateProps {
  code: string;
}

export function ScanningState({ code }: ScanningStateProps) {
  const t = useTranslations('public');

  return (
    <div className="flex flex-col gap-3 px-4" style={{ paddingBottom: 100 }}>
      {/* HoloCard back-face — animated holographic shimmer */}
      <HoloCard scanning />

      {/* URL info card */}
      <div
        className="pub-card flex items-center gap-3"
        style={{ padding: '14px 16px' }}
      >
        <div
          className="flex items-center justify-center flex-shrink-0"
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: 'var(--pub-surface-3)',
            border: '1px solid var(--pub-border)',
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="var(--pub-text-muted)" strokeWidth="2" width="16" height="16">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
        <div className="min-w-0">
          <div
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: 'var(--pub-text-primary)',
            }}
          >
            {t('scanning.label')}
          </div>
          <div
            style={{
              fontFamily: 'var(--font-pub-mono)',
              fontSize: 11,
              color: 'var(--pub-text-muted)',
              marginTop: 2,
              wordBreak: 'break-all',
            }}
          >
            {t('scanning.urlPrefix')}{code}
          </div>
        </div>
      </div>
    </div>
  );
}
